// Canonical date formatting used across the whole UI.
// Wire format (DB + API) stays ISO-8601 (YYYY-MM-DD or full ISO). Presentation
// is always DD/MM/YYYY (or DD/MM/YYYY HH:mm for datetimes). Do not use
// toLocaleDateString / toLocaleString for dates anywhere — always go through
// these helpers so a single knob controls the whole app.
//
// Empty / null / unparseable inputs always render as the em-dash "—" so
// tables never show "Invalid Date" or the 1970 epoch.

const DASH = "—";

function _parse(input) {
    if (input === null || input === undefined || input === "") return null;
    if (input instanceof Date) return isNaN(input) ? null : input;
    const d = new Date(input);
    return isNaN(d) ? null : d;
}

function _pad(n) {
    return String(n).padStart(2, "0");
}

/** Returns "DD/MM/YYYY" or "—" when input is falsy/unparseable. */
export function formatDate(input) {
    const d = _parse(input);
    if (!d) return DASH;
    return `${_pad(d.getDate())}/${_pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

/** Returns "DD/MM/YYYY HH:mm" (24-hour) or "—" when input is falsy/unparseable. */
export function formatDateTime(input) {
    const d = _parse(input);
    if (!d) return DASH;
    return `${formatDate(d)} ${_pad(d.getHours())}:${_pad(d.getMinutes())}`;
}

/** Returns "DD/MM/YYYY HH:mm:ss" — used sparingly (audit logs, some detail views). */
export function formatDateTimeSeconds(input) {
    const d = _parse(input);
    if (!d) return DASH;
    return `${formatDate(d)} ${_pad(d.getHours())}:${_pad(d.getMinutes())}:${_pad(d.getSeconds())}`;
}

/** Hint string appended to date <input> labels so users know the expected format. */
export const DATE_INPUT_HINT = "(DD/MM/YYYY)";
